<template>
    <div>
        <h3>Proxy Servers</h3>
        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Region</th>
                        <th>Address</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(server, i) in servers" :key="server.id">
                        <td>{{ i + 1 }}</td>
                        <td>{{ server.name }}</td>
                        <td>{{ server.status }}</td>
                        <td>{{ server.region }}</td>
                        <td>{{ server.address }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="alert alert-danger text-muted" role="alert">
            <small
                >Select server that near your location for best speed ––</small
            >
            <small>Servers are Backconnect proxies ––</small>
            <small>Proxy location must be set in your User/IP</small>
        </div>
    </div>
</template>

<script>
import superagent from 'superagent'

import { config, auth, response } from 'website-core'

export default {
    data() {
        return {
            servers: null,
        }
    },
    created() {
        this.getServer()
    },
    methods: {
        // TODO: move to website-core
        getServer() {
            var self = this

            superagent
                .get(config.url_api + '/server')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200 || !res.body) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.servers = res.body
                    return
                })
        },
    },
}
</script>